/**
 *
 * @param {HTMLElement} el - check element
 * @returns {boolean} -
 */
const checkOverflow = (el: any) => {
  const curOverflow = el.style.overflow;
  if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";
  const isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
  el.style.overflow = curOverflow;
  return isOverflowing;
};

export { checkOverflow };
